import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import * as firebase from 'firebase/app';

@Component({
	selector: 'app-download',
	templateUrl: './download.component.html',
	styleUrls: ['./download.component.scss']
})
export class DownloadComponent implements OnInit {

	file: any

	constructor(
		public route: ActivatedRoute,
	) { }

	ngOnInit() {
		let _ = this
		// console.log(btoa("https://attaboy-161918.appspot.com.storage.googleapis.com/uploads/-LLZWLsNtTS2lcV8CaXy/files/h0fvhLrKGyWen4cYRm954XMZt0hcck/2018-09-05_Durathon_Mumbai.mp4"))
		this.route.params.subscribe(params => {
			if (params['file']) {
				let ref = atob(params['file'])
				console.log(params['file'], ref)
				this.file = {}

				firebase.storage().ref(ref).getDownloadURL().then(function(url) {
					console.log(url, _)

					var xhr = new XMLHttpRequest()
					xhr.responseType = 'blob'
					xhr.onprogress = function(event) {
						console.log(event.loaded, event.total, ~~(event.loaded * 100 / event.total) + '%')
					}
					xhr.onload = function(event) {
						var blob = xhr.response
						_.file.path = window.URL.createObjectURL(blob)
					}
					xhr.open('GET', url)
					xhr.send()

					// This can be downloaded directly:
					// var xhr = new XMLHttpRequest();
					// xhr.responseType = 'blob';
					// xhr.onload = function(event) {
					//	 var blob = xhr.response;
					//	 _.file.path = window.URL.createObjectURL(blob)
					//	 _.file.name = ref.split('/').pop()
					// };
					// xhr.open('GET', url);
					// xhr.send();
				}).catch(function(error) {
					console.error("Error here", error);
				})
			}
		})
	}

}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/download/download.component.ts